import { h } from "../../../../tracejs/src/utils/JSXFactory";
import { injectable } from "tsyringe";

import { BaseWidgetSettings } from "../../common/BaseWidgetSettings";
import {IRailEtaSettings} from "./IRailSettings";

/**
 * Track and Trace - Origin - Settings
 */
@injectable()
export class RailEtaSettings extends BaseWidgetSettings<IRailEtaSettings>
{

    async startup(): Promise<any> {
        await super.startup();

        this.settings.widgetSettings.filters.etaMinus = null;
        this.settings.widgetSettings.filters.etaPlus = null;
        this.settings.widgetSettings.filters.etdPlus = null;
        this.settings.widgetSettings.filters.etdMinus = null;
        this.settings.widgetSettings.filters.ataPlus = null;
    }

    /**
     * Settings template
     * @returns 
     */
    public dialogTemplate = (): HTMLElement => (

        <div data-bind="with: $root.settings.widgetSettings">
            <div class="row">
                <div class="col-md-4">
                    <div className="row mb-2">
                        <label className="inline col-md-6 col-form-label" data-bind="uniqueFor: 'railEtdMinus'">ETD minus (days)</label>
                        <div className="col-md-6">
                            <input type="number" className="form-control" data-bind="value: filters.railEtdMinus, uniqueId: 'railEtdMinus'" />
                        </div>
                    </div>
                    <div className="row mb-2">
                        <label className="inline col-md-6 col-form-label" data-bind="uniqueFor: 'railEtdPlus'">ETD plus (days)</label>
                        <div className="col-md-6">
                            <input type="number" className="form-control" data-bind="value: filters.railEtdPlus, uniqueId: 'railEtdPlus'" />
                        </div>
                    </div>
                    <div className="row mb-2">
                        <label className="inline col-md-6 col-form-label" data-bind="uniqueFor: 'railAtdPlus'">ATD plus (days)</label>
                        <div className="col-md-6">
                            <input type="number" className="form-control" data-bind="value: filters.railAtdPlus, uniqueId: 'railAtdPlus'" />
                        </div>
                    </div>
                </div>
                <div class="col-md-8">

                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" data-bind="checked: filters.showRailEmergency, uniqueId: 'showRailEmergency'" />
                        <label class="form-check-label" data-bind="uniqueFor: 'showRailEmergency'"><span data-bind="i18n: 'widget.origin.showEmergency'"></span></label>
                    </div>

                </div>
            </div>

            <hr />

            <fieldset>
                <legend data-bind="i18n: 'widget.origin.colors'"></legend>
                <ul>
                    <li data-bind="i18n: 'widget.origin.descrWhite'"></li>
                    <li data-bind="i18n: 'widget.origin.descrGreen'"></li>
                    <li data-bind="i18n: 'widget.origin.descrOrange'"></li>
                    <li data-bind="i18n: 'widget.origin.descrRed'"></li>
                </ul>
            </fieldset>

            <fieldset>
                <legend data-bind="i18n: 'common.captions.description'"></legend>
                <p data-bind="i18n: 'widget.origin.descr'"></p>
            </fieldset>

            <fieldset>
                <legend data-bind="i18n: 'common.captions.notePractice'"></legend>
                <p data-bind="i18n: 'widget.origin.descr2'"></p>
            </fieldset>

        </div>
    );

}




